import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "staff-page" }

import ProductList from '@/components/ProductList.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'ProductCatalogList',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("header", { class: "page-heading" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-eyebrow" }, "Каталог"),
        _createElementVNode("h1", null, "Продукты")
      ])
    ], -1)),
    _createVNode(ProductList)
  ]))
}
}

})